import * as React from "react";

import { isDefined } from "Utils/functions";
import type { Context } from "../TextContext";
import { TextContext } from "../TextContext";
import { AppDefinedVariables } from "../textInterfaces";

export function useTexts(variables: AppDefinedVariables = {}): Context {
  const context = React.useContext(TextContext);

  if (!isDefined(context)) {
    throw new Error("'useTexts' must be wrapped by a 'TextProvider'");
  }

  React.useEffect(() => {
    context.updateVariables(variables);
  }, []);

  return context;
}
